import throwErrors from './throwErrors';

// Helper that catches common errors in forms.
export default obj => {
  if (obj) {
    if ('graphQLErrors' in obj) {
      throwErrors(obj.graphQLErrors);
    }
    Object.keys(obj).forEach(key => {
      if (key === 'data') {
        Object.keys(obj.data).forEach(field => {
          if (obj.data[field] && 'validationErrors' in obj.data[field]) {
            throwErrors(obj.data[field].validationErrors);
          }
        });
        return;
      }
      if (key === 'errors') {
        throwErrors(obj.errors);
        return;
      }
      if (obj.data[key] && 'validationErrors' in obj.data[key]) {
        throwErrors(obj.data[key].validationErrors);
      }
    });
  }
  return obj;
};



// WEBPACK FOOTER //
// ./src/helpers/catchErrors.js